var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.7337C14 1.22493 13.7246 0.76119 13.2915 0.5408C12.8584 0.3204 12.3443 0.38237 11.9691 0.7002L6.0615 5.70429H1.5C0.80964 5.70429 0.25 6.2969 0.25 7.0278V14.969C0.25 15.7 0.80964 16.2925 1.5 16.2925H6.0615L11.9691 21.2966C12.3443 21.6144 12.8584 21.6764 13.2915 21.456C13.7246 21.2356 14 20.7719 14 20.2631V1.7337ZM7.2809 8.0613L11.5 4.48747V17.5093L7.2809 13.9355C7.0592 13.7477 6.7838 13.6455 6.5 13.6455H2.75V8.3513H6.5C6.7838 8.3513 7.0592 8.2491 7.2809 8.0613ZM27.3834 6.0918C27.8716 6.6086 27.8716 7.4466 27.3834 7.9635L24.5173 10.9982L27.3834 14.0329C27.8716 14.5498 27.8716 15.3878 27.3834 15.9047C26.8952 16.4216 26.1038 16.4216 25.6156 15.9047L22.7495 12.87L19.8834 15.9047C19.3952 16.4216 18.6038 16.4216 18.1156 15.9047C17.6275 15.3878 17.6275 14.5498 18.1156 14.0329L20.9817 10.9982L18.1156 7.9635C17.6275 7.4466 17.6275 6.6086 18.1156 6.0918C18.6038 5.57488 19.3952 5.57488 19.8834 6.0918L22.7495 9.1265L25.6156 6.0918C26.1038 5.57488 26.8952 5.57488 27.3834 6.0918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteSound);
export default __webpack_public_path__ + "static/media/mute-sound.a3661b7129a9215f13045e33b0b5dff1.svg";
export { ForwardRef as ReactComponent };